import { FeatureFlag } from '@moda/portal-stanchions';
import { tc } from './trackingContext';

let trackedFlags: { [key: string]: boolean } = {};

export const clearFeatureFlagTrackingCache = () => {
  trackedFlags = {};
};

export const trackFeatureFlagView = (flagName: string, treatment: FeatureFlag) => {
  if (trackedFlags[flagName]) return;

  tc.track('Experiment Viewed', {
    addToScopeOnce: { featureFlag: { flagName, treatment } },
    addToTrackingEvent: { nonInteraction: 1 }
  });
  trackedFlags[flagName] = true;
};
